import React from "react";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@mui/material";

import { usePolygonDrawContext } from "./PolygonDrawContext";
import { formatArea, formatPerimeter } from "./helpers";
import MetricLabelMarker from "./MetricLabelMarker";

/**
 * Renders a small chip at each polygon's centroid with its title ("Area N")
 * and area/perimeter values. DOM-overlay markers so they stay legible above
 * 3D content.
 */
export default function PolygonMetricsLabels() {
  const { t } = useTranslation();
  const { isActive, polygonMetrics } = usePolygonDrawContext();

  if (!isActive) return null;

  return (
    <>
      {polygonMetrics.map((metric, index) => {
        if (!metric.centroid) return null;
        const [longitude, latitude] = metric.centroid;
        // Skeleton while the polygon's measurement is in flight, dash when
        // the measurement failed.
        const secondary = metric.isMeasuring ? (
          <Skeleton variant="text" width={110} sx={{ mx: "auto" }} />
        ) : metric.hasError ? (
          "—"
        ) : (
          `${formatArea(metric.area, t)} · ${formatPerimeter(metric.perimeter, t)}`
        );
        return (
          <MetricLabelMarker
            key={metric.id}
            longitude={longitude}
            latitude={latitude}
            primary={`${t("risksMap.polygon.polygonLabel")} ${index + 1}`}
            secondary={secondary}
          />
        );
      })}
    </>
  );
}
